import * as React from "react";

import { CnecInfoDto } from "core/backend/data";
import { MultiSelectItem } from "components/multiselect";
import { WithTranslation, withTranslation } from "react-i18next";
import TDatetime from "components/TDatetime";
import CheckIcon from "components/checkIcon";
import classNames from "classnames";

interface OwnProps {
    dto: CnecInfoDto;
    hubs: MultiSelectItem[];
    left: number;
}

const Row = ({t, dto, hubs, left }: OwnProps & WithTranslation) => {
    let eic = "N/A", from = "N/A", to = "N/A";
    if (dto.contingencies[0].name !== "N situation") {
        eic = dto.contingencies[0].eic;
        from = dto.contingencies[0].hubFrom;
        to = dto.contingencies[0].hubTo;
    }
    return (<>
        <tr>
            <TDatetime rowSpan={dto.contingencies.length} date={new Date(dto.dateTimeUtc)} left={left} />
            <td rowSpan={dto.contingencies.length}>{dto.cneName}</td>
            <td rowSpan={dto.contingencies.length}>{dto.cneEic}</td>
            <td className="text-disabled" rowSpan={dto.contingencies.length}>{dto.direction}</td>
            <td rowSpan={dto.contingencies.length}>{dto.hubFrom}</td>
            <td rowSpan={dto.contingencies.length}>{dto.hubTo}</td>

            <td className="lineLeft">{dto.contingencies[0].name}</td>
            <td>{eic}</td>
            <td>{from}</td>
            <td>{to}</td>

            <td rowSpan={dto.contingencies.length} className="lineLeft">{dto.sensitivity}</td>
            <td rowSpan={dto.contingencies.length}><CheckIcon checked={dto.selected} /></td>
            <td rowSpan={dto.contingencies.length}><CheckIcon checked={dto.limiting} /></td>

            <td rowSpan={dto.contingencies.length} className="lineLeft">{dto.fmax}</td>
            <td rowSpan={dto.contingencies.length}>{dto.fref}</td>
            <td rowSpan={dto.contingencies.length}>{dto.fntc}</td>

            <td className="lineLeft" rowSpan={dto.contingencies.length}>{dto.mncc}</td>
            <td rowSpan={dto.contingencies.length}>{dto.mccc}</td>
            <td rowSpan={dto.contingencies.length}>{dto.totalMaczt}</td>

            {hubs.map((hub, i) => <td key={hub.id} rowSpan={dto.contingencies.length} className={classNames("", i === 0 ? "lineLeft" : "")}>{eval("dto.ptdfNtcs_IT_" + hub.id.toUpperCase())}</td>) /* Import */ }
            {hubs.map((hub) => <td key={hub.id} rowSpan={dto.contingencies.length}>{eval("dto.ptdfNtcs_" + hub.id.toUpperCase() + "_IT")}</td>) /* Export */ }
            {hubs.map((hub, i) => <td key={hub.id} rowSpan={dto.contingencies.length} className={classNames(i === 0 ? "lineLeft" : "")}>{eval("dto.ptdfRefs_IT_" + hub.id.toUpperCase())}</td>) /* Import */ }
            {hubs.map((hub) => <td key={hub.id} rowSpan={dto.contingencies.length}>{eval("dto.ptdfRefs_" + hub.id.toUpperCase() + "_IT")}</td>) /* Export */ }

            <td className="lineLeft" rowSpan={dto.contingencies.length}>{dto.frm}</td>
            <td rowSpan={dto.contingencies.length}>{dto.fltn}</td>
            <td rowSpan={dto.contingencies.length}>{dto.ram}</td>
            <td rowSpan={dto.contingencies.length}>{dto.amr}</td>
            <td className="text-disabled" rowSpan={dto.contingencies.length}>{dto.ltaMargin}</td>
        </tr>
        {
            dto.contingencies.slice(1).map((c) =>
                <tr key={c.number}>
                    <td className="alignRight">{t("ibwt_cnec:additionalBranch")}{c.number}: {c.name}</td>
                    <td>{c.eic}</td>
                    <td>{c.hubFrom}</td>
                    <td>{c.hubTo}</td>
                </tr>
            )
        }
    </>)
};

const translated = withTranslation("ibwt_cnec")(Row);

export default translated;